import { ELocalStorageKeys } from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';

export class StarredProjectsUtils {
    static getStarredProjects(): Set<string> {
        const starred = localStorageUtil.get<string[]>(ELocalStorageKeys.STARRED_PROJECTS);
        return new Set(starred || []);
    }

    static toggleStarredProject(projectId: string): void {
        const starred = localStorageUtil.get<string[]>(ELocalStorageKeys.STARRED_PROJECTS) || [];

        if (starred.includes(projectId)) {
            // Remove from array
            const filteredStarred = starred.filter(id => id !== projectId);
            localStorageUtil.set(ELocalStorageKeys.STARRED_PROJECTS, filteredStarred);
        } else {
            // Add to beginning of array (most recent first)
            const newStarred = [projectId, ...starred];
            localStorageUtil.set(ELocalStorageKeys.STARRED_PROJECTS, newStarred);
        }
    }

    static isProjectStarred(projectId: string): boolean {
        const starred = localStorageUtil.get<string[]>(ELocalStorageKeys.STARRED_PROJECTS) || [];
        return starred.includes(projectId);
    }

    static clearStarredProjects(): void {
        localStorageUtil.remove(ELocalStorageKeys.STARRED_PROJECTS);
    }
}
